module.exports = __webpack_public_path__ + "static/img/zj-sh4.84dca661.png";